import { render, staticRenderFns } from "./ProdutoIbpModal.vue?vue&type=template&id=77f94670&scoped=true"
import script from "./ProdutoIbpModal.vue?vue&type=script&lang=js"
export * from "./ProdutoIbpModal.vue?vue&type=script&lang=js"
import style0 from "./ProdutoIbpModal.vue?vue&type=style&index=0&id=77f94670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f94670",
  null
  
)

export default component.exports